import { OnInit } from '@angular/core';
var CsAgDetailGridRendererComponent = /** @class */ (function () {
    function CsAgDetailGridRendererComponent() {
    }
    CsAgDetailGridRendererComponent.prototype.ngOnInit = function () {
    };
    CsAgDetailGridRendererComponent.prototype.onGridInit = function (instance) {
        this.params['node']['parent']['detailMetaData']['gridInstance'] = instance;
    };
    return CsAgDetailGridRendererComponent;
}());
export { CsAgDetailGridRendererComponent };
